export const cutBranch = ( tree, soughtId ) => {
    for( var i = 0; i < tree.length; i++ ) {
        var node = tree[ i ];
        if( node.id == soughtId ) {
            return [ node ];
        }
        if( node.child_categories.length > 0 ) {
            var limb = cutBranch( node.child_categories, soughtId );
            if( limb ) {
                return [ node, ...limb ];
            }
        }
    }
    return false;
};
